import React, { Component, Fragment } from "react";

class UserLayout extends Component {
  componentDidMount() {
    document.body.classList.add("background");
  }
  componentWillUnmount() {
    document.body.classList.remove("background");
  }

  render() {
    return (
      <Fragment>
        <div className="fixed-background">
          {window.tenant.url.includes("theschool.cool") && <img src={window.tenant.hero} alt="" style={{filter: "brightness(0.5) blur(4px)"}}/>}
        </div>
        <main>
          <div className="container">{this.props.children}</div>
        </main>
      </Fragment>
    );
  }
}

export default UserLayout;
